import { computed } from 'mobx';
import CourierStoresCollection, { ICourierTimesData } from '../../domain/entities/Store/CourierStoresCollection';
import StoresRepository, { IStoresRepositoryConfig } from '../StoresRepository';

export type ICourierStoresRepositoryConfig = IStoresRepositoryConfig;
export default class CourierStoresRepository extends StoresRepository {
  constructor(props: ICourierStoresRepositoryConfig) {
    super(props);
    this.storesCollection = new CourierStoresCollection();
  }

  @computed
  get courierStoresCollection(): CourierStoresCollection {
    return this.storesCollection as CourierStoresCollection;
  }

  setCourier = async (
    doorId: string,
    addressId: number,
    dropoffNotes?: string,
    courierTimeData?: ICourierTimesData,
  ): Promise<void> => {
    const body = {
      addressId,
      doorId,
      dropoffNotes,
      ...courierTimeData,
    };
    const courierStoresCollection = this.storesCollection as CourierStoresCollection;
    try {
      const { isAddressUndeliverable } = await this.api.setCourier(body);
      courierStoresCollection.setIsAddressUndeliverable(isAddressUndeliverable);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
      courierStoresCollection.setIsAddressUndeliverable(true);
    }
  };
}
